<template>
  <el-form class="billing-info" :size="size">
    <el-form-item v-if="showBusiness">
      <el-radio v-model="form.business" label="0">Individual</el-radio>
      <el-radio v-model="form.business" label="1">Business</el-radio>
    </el-form-item>

    <el-form-item>
      <el-input
        v-if="edit"
        v-model="form.name"
        :placeholder="placeholder"
        @change="$emit('update:name', $event)"
      />
      <strong class="name" v-else>{{ form.name }}</strong>
    </el-form-item>

    <el-form-item v-if="showEmail" :error="error">
      <el-input
        v-if="edit"
        v-model="form.email"
        placeholder="Billing Email"
        @change="updateEmail"
      />
    </el-form-item>

    <el-form-item v-if="sortedCountries">
      <template v-if="edit">
        <el-input v-model="form.address.line1" placeholder="Address" @change="updateAddress" />
        <el-input
          v-model="form.address.line2"
          v-show="form.address.line1"
          placeholder="Address line 2"
          @change="updateAddress"
        />

        <el-row :gutter="10">
          <el-col :span="8">
            <el-input v-model="form.address.postal_code" placeholder="Postal code" @change="updateAddress" />
          </el-col>
          <el-col :span="16">
            <el-input v-model="form.address.city" placeholder="City" @change="updateAddress" />
          </el-col>
        </el-row>

        <el-select v-model="form.address.country" filterable @change="updateAddress">
          <el-option
            v-for="country in sortedCountries"
            :key="country.code"
            :label="country.name"
            :value="country.code"
          />
        </el-select>
      </template>

      <div class="address" v-else>
        <div>{{ form.address.line1 }}</div>
        <div v-if="form.address.line2">{{ form.address.line2 }}</div>
        <div>{{ form.address.postal_code }} {{ form.address.city }} {{ form.address.country }} {{ emoji }}</div>
        {{ form.email }}
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
import { countries } from 'countries-list'
import isEmail from 'validator/lib/isEmail'

export default {
  props: {
    size: {
      type: String,
      default: 'medium'
    },
    edit: {
      type: Boolean,
      default: true
    },
    showBusiness: {
      type: Boolean,
      default: false
    },
    showEmail: {
      type: Boolean,
      default: true
    },
    name: String,
    email: String,
    business: {
      type: String,
      default: '1'
    },
    address: {
      type: Object,
      default: () => ({
        city: null,
        line1: null,
        line2: null,
        postal_code: null
      })
    }
  },
  data () {
    const sortedCountries = []
    for (const code in countries) {
      sortedCountries.push({
        code,
        ...countries[code]
      })
    }
    sortedCountries.sort((a, b) => a.name.localeCompare(b.name))
    return {
      sortedCountries,
      error: null,
      form: {
        name: this.name,
        email: this.email,
        business: this.business,
        address: {
          country: this.$root.language.country,
          ...this.address
        }
      }
    }
  },
  computed: {
    placeholder () {
      return this.form.business === '1' ? 'Company Name' : 'Your Name'
    },
    emoji () {
      return this.form.address && this.form.address.country &&
        countries[this.form.address.country] ? countries[this.form.address.country].emoji : ''
    }
  },
  methods: {
    updateAddress () {
      this.$nextTick(() => this.$emit('update:address', { ...this.form.address }))
    },
    updateEmail () {
      if (this.form.email && !isEmail(this.form.email)) {
        this.error = 'Your email is incorrect. Please check, and try again.'
      } else {
        this.$emit('update:email', this.form.email)
        this.error = null
      }
    }
  },
  watch: {
    name (value) {
      this.form.name = value
    },
    email (value) {
      this.form.email = value
    },
    business (value) {
      this.form.business = value
    },
    address (value) {
      this.form.address = value
    }
  }
}
</script>

<style lang="scss" scoped>
  .billing-info {
    max-width: 400px;

    .name {
      font-size: 13px;
      margin-bottom: -1px;
      display: block;
    }
    .address {
      font-size: 13px;
      line-height: 17px;
      margin-bottom: 15px;
    }
    .el-select {
      width: 100%;
    }
    .el-select, .el-input {
      margin-bottom: 5px;
    }
    .el-row {
      margin-bottom: 0;
    }
    .el-form-item:not(.is-error) {
      margin-bottom: 0px;
    }
  }
</style>
